// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5040) return "static/chunks/5040-af5a5ae3dd5404a9.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"5996":"121d6436","7024":"0e2dffd8"}[chunkId] || chunkId) + "." + {"716":"45e988362ebc260d","1025":"46bd4b615a9f7c63","1882":"c1e99116d6aab447","4934":"1e0e82105803af81","5996":"da90e1334c1a36f8","6531":"5f0bbe76786a40a5","7024":"d8124a69926f2578"}[chunkId] + ".js";
};